import { render } from "./SlideList.vue?vue&type=template&id=250e88e9&scoped=true"
import script from "./SlideList.vue?vue&type=script&lang=js"
export * from "./SlideList.vue?vue&type=script&lang=js"

import "./SlideList.vue?vue&type=style&index=0&id=250e88e9&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250e88e9"]])

export default __exports__